module.exports = __webpack_public_path__ + "static/media/pe.4161fd48.svg";